import { Link } from 'react-router'

/**
 * The way back to the games.
 *
 * On the page rather than only in the browser chrome, because there is a
 * Raspberry Pi on a television running in kiosk mode where there is no back
 * button and no address bar. Before this, leaving a game meant knowing to
 * Shift+Tab twice to the header — which is not something an eight-year-old
 * knows, and not something anybody should have to be told.
 *
 * Hidden on the television, and only there. The pinned legend along the bottom
 * already says Esc goes back, on the one display that has no mouse to press
 * this with — so here it is a second way to do the same thing, taking room in
 * the middle of the screen. On a phone it is the *only* way, since there is no
 * legend and no keyboard, so it stays.
 */
export function LeaveGame() {
  return (
    <Link
      to="/"
      className="text-ink-muted hover:text-ink inline-flex min-h-(--size-tap) items-center justify-center self-center text-(length:--text-small) no-underline [[data-scale=tv]_&]:hidden"
    >
      ← Back to the games
    </Link>
  )
}
